(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-variants"] && !Shopify.designMode) return;
  try {
    
  var links = document.querySelectorAll('.related-variants__option');
  var currentPath = window.location.pathname;
  links.forEach(function(link) {
    if (link.tagName === 'A' && link.getAttribute('href') === currentPath) {
      var span = document.createElement('span');
      span.className = 'related-variants__option related-variants__option--active';
      span.textContent = link.textContent;
      link.parentNode.replaceChild(span, link);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
